const GET_ONE_ROUTE_REQUEST = "GET_ONE_ROUTE_REQUEST"
const GET_ONE_ROUTE_SUCCESS = "GET_ONE_ROUTE_SUCCESS"
const GET_ONE_ROUTE_FAILURE = "GET_ONE_ROUTE_FAILURE"

export {GET_ONE_ROUTE_REQUEST,GET_ONE_ROUTE_SUCCESS,GET_ONE_ROUTE_FAILURE}